/*
 * OASIS NATION — Detail beat scrubber (2up wheel/chrome).
 * Same engine family as the hero: scrub a buffered all-keyframe video on scroll,
 * with cursor parallax + ambient breathing. Touch/reduced-motion = loop fallback.
 */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-detail]');
    if (!root) return;
    var stage = root.querySelector('[data-detail-stage]');
    var canvas = root.querySelector('[data-detail-canvas]');
    var video = root.querySelector('[data-detail-video]');
    if (!canvas || !video || !stage) return;

    var ctx = canvas.getContext('2d', { alpha: false });
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var small = window.matchMedia('(max-width: 749px)').matches;
    var SCRUB_END = 1.0;

    if (reduced || coarse || small) {
      root.classList.add('is-fallback');
      var loop = video.getAttribute('data-loop');
      if (loop) { video.src = loop; video.load(); }
      video.loop = true; video.muted = true; video.playsInline = true;
      var tryPlay = function () { video.play().catch(function () {}); };
      video.addEventListener('canplay', tryPlay, { once: true });
      tryPlay();
      root.classList.add('detail-ready');
      return;
    }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var dur = 3.7, ready = false, curT = 0, targetT = 0, curZoom = 1.04;
    var mTX = 0, mTY = 0, mX = 0, mY = 0, phase = 0, bx = 0, by = 0;

    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      draw();
    }
    function draw() {
      if (!video.videoWidth) return;
      var w = canvas.width, h = canvas.height;
      var s = Math.max(w / video.videoWidth, h / video.videoHeight) * curZoom;
      var dw = video.videoWidth * s, dh = video.videoHeight * s;
      var ox = (w - dw) / 2 - (mX + bx) * (dw - w) * 0.45;
      var oy = (h - dh) / 2 - (mY + by) * (dh - h) * 0.45;
      ctx.drawImage(video, ox, oy, dw, dh);
    }

    video.muted = true; video.playsInline = true;
    var kicked = false;
    function bufferKick() {
      if (kicked) return; kicked = true;
      var pr = video.play();
      if (pr && pr.then) pr.then(function () { video.pause(); }).catch(function () { kicked = false; });
    }
    video.addEventListener('loadedmetadata', function () { dur = video.duration || 3.7; resize(); bufferKick(); });
    video.addEventListener('loadeddata', function () {
      ready = true;
      try { video.currentTime = 0; } catch (e) {}
      root.classList.add('detail-ready');
    });
    video.addEventListener('seeked', draw);
    if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
      var rvfc = function () { draw(); video.requestVideoFrameCallback(rvfc); };
      video.requestVideoFrameCallback(rvfc);
    }
    bufferKick();

    function progress() {
      var rect = root.getBoundingClientRect();
      var total = root.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      return Math.max(0, Math.min(1, (-rect.top) / total));
    }

    var lastSet = -1;
    function tick() {
      var p = progress();
      var sp = Math.min(1, p / SCRUB_END);
      targetT = sp * (dur - 0.05);
      curT += (targetT - curT) * 0.32;
      phase += 0.016;
      bx = Math.sin(phase * 0.27) * 0.3;
      by = Math.cos(phase * 0.21) * 0.26;
      curZoom = 1.04 + sp * 0.05 + Math.sin(phase * 0.5) * 0.005;
      mX += (mTX - mX) * 0.06;
      mY += (mTY - mY) * 0.06;
      if (ready && Math.abs(curT - lastSet) > 0.012) {
        try { video.currentTime = curT; lastSet = curT; } catch (e) {}
      }
      draw();
      root.style.setProperty('--detail-p', p.toFixed(3));
      root.style.setProperty('--detail-reveal', Math.max(0, Math.min(1, (p - 0.22) / 0.4)).toFixed(3));
      requestAnimationFrame(tick);
    }

    window.addEventListener('resize', resize);
    window.addEventListener('mousemove', function (e) {
      mTX = e.clientX / window.innerWidth - 0.5;
      mTY = e.clientY / window.innerHeight - 0.5;
    }, { passive: true });
    resize();
    requestAnimationFrame(tick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
